"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = exports.TagRemove = void 0;

var React = _interopRequireWildcard(require("react"));

var _Box = require("grommet/components/Box");

var _Button = require("grommet/components/Button");

var _Text = require("grommet/components/Text");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TagRemove = function TagRemove(_ref) {
  var remove = _ref.remove;
  return React.createElement(_Button.Button, {
    href: "#",
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      remove();
    },
    onFocus: function onFocus(event) {
      return event.stopPropagation();
    }
  }, React.createElement(_Box.Box, null, React.createElement(_Icons.CancelIcon, {
    color: "black60",
    style: {
      width: '12px',
      height: '12px',
      paddingTop: '1px'
    }
  })));
};

exports.TagRemove = TagRemove;

var StyledDiv = _styledComponents.default.div.withConfig({
  displayName: "StyledDiv",
  componentId: "sc-11hyccw-0"
})(["display:flex;justify-content:center;align-items:center;color:", ";padding:4px 12px;background-color:", ";border-radius:20px;margin:6px;"], (0, _helpers.color)('black100'), (0, _helpers.color)('primary10'));

var StyledTextDiv = _styledComponents.default.div.withConfig({
  displayName: "StyledTextDiv",
  componentId: "sc-11hyccw-1"
})(["float:left;"]);

var StyledRemoveTagDiv = _styledComponents.default.div.withConfig({
  displayName: "StyledRemoveTagDiv",
  componentId: "sc-11hyccw-2"
})(["float:right;width:12px;margin-left:3px;display:inline-block;"]);

var Tag = function Tag(_ref2) {
  var value = _ref2.value,
      label = _ref2.label,
      remove = _ref2.remove,
      disabled = _ref2.disabled;
  return React.createElement(StyledDiv, {
    key: value
  }, React.createElement(StyledTextDiv, null, React.createElement(_Text.Text, {
    color: "black100",
    margin: {
      right: 'xsmall'
    }
  }, label)), React.createElement(StyledRemoveTagDiv, null, !disabled && React.createElement(TagRemove, {
    remove: remove
  })));
};

exports.Tag = Tag;